import starYellow from '../../../../assets/img/star-yellow.png';
import starGrey from '../../../../assets/img/star-grey.png';
import React from 'react';

const FavouriteStar = ({ isFavorite, onToggleFavourite }) => {
  if (isFavorite) {
    return (
      <div className="m-1" onClick={onToggleFavourite}>
        <img
          src={starYellow}
          alt="favorite"
          style={{ opacity: '1', width: '16px' }}
        ></img>
      </div>
    );
  } else {
    return (
      <div className="m-1" onClick={onToggleFavourite}>
        <img
          src={starGrey}
          alt="not-favorite"
          style={{ opacity: '1', width: '16px' }}
        ></img>
      </div>
    );
  }
};

export default FavouriteStar;
